/// <reference path="../types/index.d.ts" />

import '../client_forms/plattduetsche/style.css';
import FormStructure from './plattduetsche/form_structure';

export default FormStructure;